import { render, staticRenderFns } from "./TelemedicinePendingTable.vue?vue&type=template&id=88933b2a&"
import script from "./TelemedicinePendingTable.vue?vue&type=script&lang=js&"
export * from "./TelemedicinePendingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports